import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../@types/user";

export const initialUserState: User = {
    isAuthenticated: false,
    profile: {}
};

const slice = createSlice({
    name: "user",
    initialState: initialUserState,
    reducers: {
        setUserState(state, action: PayloadAction<User>) {
            // Update state properties explicitly
            state.isAuthenticated = action.payload.isAuthenticated;
            state.profile = action.payload.profile;

            return state;
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const { setUserState } = slice.actions;